module.exports = __webpack_public_path__ + "img/default-google-maps-black.9ab20028.png";